import {
    Component
} from '@theme/component';
export class PublicPopup extends Component {
    constructor() {
        super();
        this.popupEl=this.querySelector('.popup');
        this.closeIconEl=this.querySelector('.close-popup');
        this.closeIconEl?.addEventListener('click',this.closePopup.bind(this));
        this.shareBtnGroupEl=this.querySelector('.shareBtnGroup');   
        this.shareBtnGroupEl?.querySelectorAll('button').forEach((btn) => {
            btn.addEventListener('click', (e) => {
                this.shareFn(e);
            });
        });
    }
    connectedCallback() {
        super.connectedCallback();
       
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    closePopup() {
       this.popupEl.style.display='none';
    }
    shareFn(e){
        const url = window.location.href;
        const title = document.title;
        if(e.target.dataset.share==='facebook'){
            this.shareToFacebook(url, `${title}`, '#faithtag Daily Verse');
        }else if(e.target.dataset.share==='instagram'){
            this.shareToIns(url, `${title}`, '#faithtag Daily Verse');
        }else if(e.target.dataset.share==='pinterest'){
            this.shareToPinterestPin(url, `${title}`, '#faithtag Daily Verse');
        }else if(e.target.dataset.share==='twitter'){
            this.shareToTwitter(url, `${title}`, '#faithtag Daily Verse');
        }
    }
    shareToFacebook(url, quote = '', hashtag = '') {
        let shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        
        if (quote) {
            shareUrl += `&quote=${encodeURIComponent(quote)}`;
        }
        
        if (hashtag) {
            shareUrl += `&hashtag=${encodeURIComponent(hashtag)}`;
        }

        const width = 626;
        const height = 436;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;

        window.open(
            shareUrl,
            'facebook-share',
            `width=${width},height=${height},top=${top},left=${left}`
        );
    }
    shareToIns(url, title = '', description = '') {
        const shareUrl = `https://www.instagram.com/create/details/?media=${encodeURIComponent(url)}`;
        window.open(shareUrl, '_blank', 'width=600,height=700');
    }
    shareToPinterestPin(url, media, description) {
        const pinterestShareUrl = `https://pinterest.com/pin/create/link/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(media)}&description=${encodeURIComponent(description)}`;
        window.open(pinterestShareUrl, '_blank', 'width=600,height=700');
    }
    shareToTwitter(url, title){
        const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
        window.open(shareUrl, '_blank', 'width=600,height=700');
    }
}

if (!customElements.get('public-popup')) {
    customElements.define('public-popup', PublicPopup);
}